var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filters-renderer',{attrs:{"widgets-map":_vm.$options.widgetsMap,"prepared-filters":_vm.filters,"update-multiple-values":_vm.updateMultipleValues,"update-value":_vm.updateValue,"value":_vm.preparedValues}})}
var staticRenderFns = []

export { render, staticRenderFns }